module.exports = __webpack_public_path__ + "img/case-logo-15.26c0bbe0.png";